// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@flip/XDL/Utilities";
import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: flex;
        border-bottom: 1px solid ${getColor("common.border")};
        padding-bottom: 10px;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: flex-end;
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex: 1 1 200px;
            margin-bottom: 15px;
        `,
    },
    mergeCss: true,
};

customerSelectorToolbarStyles.searchButton = {
    css: css`
        margin-left: 15px;
    `,
    mergeCss: true,
};

customerSelectorToolbarStyles.wideHidden = {
    css: css`
        width: 100%;
        display: flex;
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    variant: "secondary",
    css: css`
        margin-left: auto;
    `,
};
